<template>
  <div class="flex items-center">
    <div class="flex w-full bg-white shadow rounded">
      <input class="relative w-full px-6 py-3 rounded-r focus:ring" autocomplete="off" type="text" name="search" placeholder="Pesquise..." :value="value" @input="$emit('input', $event.target.value)" />
    </div>
    <button class="ml-3 text-sm text-white bg-red-500 py-3 px-4 focus:text-indigo-500" type="button" @click="$emit('reset')">Limpar</button>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
}
</script>
